import { MdCheck } from 'react-icons/md'
import styled from 'styled-components'

import Form from '../../../../../../shared/components/Form'
import Input from '../../../../../../shared/components/Input'
import { colors } from '../../../../../../shared/styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const StyledForm = styled(Form)`
  padding-top: 20px;
  padding-bottom: 0px;
`

export const StyledFormFullAddress = styled(Form)`
  padding: 0px;
`

export const Title = styled.span`
  color: ${colors.green};
  font-weight: 700;
  font-size: 16px;
  padding-top: 30px;
`

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
`

export const SubText = styled.p`
  font-size: 14px;
  color: ${colors.grayDark};
  text-align: center;

  margin-top: 15px;
`
export const StyledCheck = styled(MdCheck)`
  color: ${colors.blue};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border: 3px solid ${colors.blue};
  border-radius: 50%;
`

export const ContainerModal = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  padding: 10px;
`

export const TextModal = styled.p`
  font-weight: 700;
  font-size: 24px;
  color: ${colors.blue};
  text-align: center;
`

export const StyledInput = styled(Input)``
